import { Slider as MUISlider, SliderProps } from '@mui/material';

export { type SliderProps } from '@mui/material';

export function Slider(props: SliderProps) {
  return <MUISlider {...props} />;
}
